import { Bijection, bijectionCompose } from "@redotech/util/bijection";
import { utf8Encoding } from "@redotech/util/encoding";
import { KeyFn } from "@redotech/util/key";
import { StringFormat } from "@redotech/util/string-format";

export type Json =
  | JsonArray
  | JsonBoolean
  | JsonObject
  | JsonNumber
  | JsonNull
  | JsonString
  | {};

export interface JsonArray extends Array<Json> {}

export type JsonBoolean = boolean;

export interface JsonObject {
  [key: JsonString]: Json;
}

// This is just to satisfy the type checker.
// Empty objects are valid JsonObjects but the type checker want there to be some key in there to make sure its a string and not something else.
export type JsonObjectWithEmpty = JsonObject | {};

export type JsonNumber = number;

export type JsonNull = null;

export type JsonString = string;

export const jsonStringFormat: StringFormat<Json> = {
  read(string: string) {
    return JSON.parse(string);
  },
  write(value: Json) {
    return JSON.stringify(value);
  },
};

export const jsonBufferFormat: Bijection<ArrayBuffer, Json> = bijectionCompose(
  utf8Encoding,
  jsonStringFormat,
);

export const jsonKeyFn: KeyFn<Json> = jsonStringFormat.write;

/**
 * Result of JSON.parse(JSON.stringify(t))
 */
export type Jsonified<T> = T extends { toJSON(): infer R }
  ? R
  : T extends string | number | boolean | null
    ? T
    : T extends (infer E)[]
      ? Jsonified<E>[]
      : T extends (...args: never) => unknown
        ? never
        : T extends object
          ? { [K in keyof T]: Jsonified<T[K]> }
          : never;
